var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCugatetv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#07294C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1.2c5.96,0,10.8,4.84,10.8,10.8S17.96,22.8,12,22.8S1.2,17.96,1.2,12S6.04,1.2,12,1.2 M12,0 C5.37,0,0,5.37,0,12c0,6.63,5.37,12,12,12s12-5.37,12-12C24,5.37,18.63,0,12,0L12,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.21,6.56c-0.29-0.72-0.82-1.33-1.49-1.7l0,0C10.44,4.63,11.2,4.5,12,4.5c4.14,0,7.5,3.36,7.5,7.5 c0,4.14-3.36,7.5-7.5,7.5c-4.14,0-7.5-3.36-7.5-7.5c0-0.99,0.19-1.93,0.54-2.8l0,0c0.33,0.7,0.89,1.27,1.59,1.61l0,0 C6.54,11.19,6.5,11.59,6.5,12c0,3.04,2.46,5.5,5.5,5.5c3.04,0,5.5-2.46,5.5-5.5c0-3.04-2.46-5.5-5.5-5.5l0,0 C11.73,6.5,11.47,6.52,11.21,6.56L11.21,6.56z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,8.08c2.16,0,3.92,1.76,3.92,3.92s-1.76,3.92-3.92,3.92S8.08,14.16,8.08,12c0-0.27,0.03-0.53,0.08-0.79 l0-0.02c0.06,0,0.12,0.01,0.18,0.01c1.72,0,3.11-1.38,3.13-3.09l0,0C11.65,8.09,11.82,8.08,12,8.08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCugatetv);
export default __webpack_public_path__ + "static/media/icon-cugatetv.0e9f71be59e398fcb18a14806eef118a.svg";
export { ForwardRef as ReactComponent };